var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"12","dense":""}},[_c('v-select',{attrs:{"dense":"","outlined":"","items":_vm.options,"chips":_vm.isMultiple,"multiple":_vm.isMultiple,"clearable":""},on:{"change":_vm.change},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }